import React from "react";
import ServicePlanPriceIntervals from "./ServicePlanPriceIntervals";
import { VehicleModelData, VehicleModel } from "../models/ServicePlanModels";
import { observer } from "mobx-react";
import ServicePlanReactSelectWrap from "./ServicePlanReactSelectWrap";

export interface ServicePlanPriceGuideProps {
  vehicleModelsListForSelectControl: any;
  vehicleModelDataList: VehicleModelData[];
  selectedModel: string;
  showTotals: boolean;
  cmsContent: VehicleModel[];
  onSelectedModelChange: Function;
  isServicePlan: boolean;
  selectedModelVariant: string;
  handleModelVariantChange: Function;
}

const ServicePlanPriceGuide: React.SFC<ServicePlanPriceGuideProps> = observer(
  (props) => {
    const { selectedModelVariant, vehicleModelDataList } = props;
    const cmsContentForSelectedModel = props.cmsContent.find(
      (x) =>
        x.modelID.toLocaleLowerCase() ===
        props.selectedModel.toLocaleLowerCase()
    );

    let modelServicePlanContent = "";
    let modelCappedPriceServiceContent = "";

    const vehicleSubNav = "Outback";

    let serviceIntervalsList = null;

    if (
      cmsContentForSelectedModel.name
        .toLocaleLowerCase()
        .includes(vehicleSubNav.toLocaleLowerCase())
    ) {
      if (
        !!selectedModelVariant &&
        selectedModelVariant.includes("Wilderness")
      ) {
        serviceIntervalsList = vehicleModelDataList
          .find(
            (apiRespModel) =>
              apiRespModel.id.toUpperCase() ===
              props.selectedModel.toUpperCase()
          )
          .intervalData.filter(
            (i) =>
              i.name.includes("Health Check and Chat") ||
              i.modelVariantServicePrices.find(
                (m) =>
                  !m.isNotApplicable && m.variantName.includes("Wilderness")
              )
          );
      } else if (
        !!selectedModelVariant &&
        selectedModelVariant.includes("XT")
      ) {
        serviceIntervalsList = vehicleModelDataList
          .find(
            (apiRespModel) =>
              apiRespModel.id.toUpperCase() ===
              props.selectedModel.toUpperCase()
          )
          .intervalData.filter(
            (i) =>
              i.name.includes("Health Check and Chat") ||
              i.modelVariantServicePrices.find(
                (m) => !m.isNotApplicable && m.variantName.includes("XT")
              )
          );
      } else {
        serviceIntervalsList = vehicleModelDataList
          .find(
            (apiRespModel) =>
              apiRespModel.id.toUpperCase() ===
              props.selectedModel.toUpperCase()
          )
          .intervalData.filter(
            (i) =>
              i.name.includes("Health Check and Chat") ||
              i.modelVariantServicePrices.find(
                (m) =>
                  !m.isNotApplicable &&
                  !(
                    m.variantName.includes("XT") ||
                    m.variantName.includes("Wilderness")
                  )
              )
          );
      }
      const selectedVariant = cmsContentForSelectedModel.variants.find(
        (v) => v.servicePriceVariantName === selectedModelVariant
      );
      if (!!selectedVariant) {
        modelServicePlanContent = selectedVariant.modelServicePlanContent;
        modelCappedPriceServiceContent =
          selectedVariant.modelCappedPriceServiceContent;
      }
    } else {
      serviceIntervalsList = props.vehicleModelDataList.find(
        (x) => x.id.toUpperCase() === props.selectedModel.toUpperCase()
      ).intervalData;
      modelServicePlanContent =
        cmsContentForSelectedModel.modelServicePlanContent;
      modelCappedPriceServiceContent =
        cmsContentForSelectedModel.modelCappedPriceServiceContent;
    }

    const ctaLabels = props.cmsContent
      .find(
        (model) =>
          model.modelID.toLocaleLowerCase() ===
          props.selectedModel.toLocaleLowerCase()
      )
      .variants.filter(
        (filterVariant) =>
          filterVariant.variantGUID !== null &&
          !!filterVariant.servicePriceVariantName
      )
      .map((label) => label.servicePriceVariantName);

    return (
      <div className="service-plan-mobile">
        <ServicePlanReactSelectWrap
          selectedModel={props.selectedModel}
          options={props.vehicleModelsListForSelectControl}
          reactSelectProps={{ clearable: false, id: "vehicleModelSelectField" }}
          onChange={(e) => {
            if (e.value) {
              const _thisModel = props.cmsContent.find(
                (x) =>
                  x.modelID.toLocaleLowerCase() === e.value.toLocaleLowerCase()
              );
              props.onSelectedModelChange(_thisModel);
            }
          }}
        />
        {cmsContentForSelectedModel.name
          .toLocaleLowerCase()
          .includes(vehicleSubNav.toLocaleLowerCase()) && (
          <div className="cappedPricingTableHeading">
            <div className="cta_wrapper">
              <h5>
                Please select your {cmsContentForSelectedModel.name} variant
              </h5>
              {ctaLabels.map((label, i) => {
                return (
                  <a
                    key={i}
                    className={
                      selectedModelVariant !== label ? "cta-button" : ""
                    }
                    onClick={(e) => props.handleModelVariantChange(e)}
                  >
                    {label}
                  </a>
                );
              })}
            </div>
          </div>
        )}

        {(!cmsContentForSelectedModel.name
          .toLocaleLowerCase()
          .includes(vehicleSubNav.toLocaleLowerCase()) ||
          (cmsContentForSelectedModel.name
            .toLocaleLowerCase()
            .includes(vehicleSubNav.toLocaleLowerCase()) &&
            !!selectedModelVariant)) && (
          <div>
            <div className="panel">
              <div className="panel-heading">
                Scheduled Service Intervals
                <sup>{props.isServicePlan ? 2 : 1}</sup>
              </div>
              <div className="panel-body">
                <ServicePlanPriceIntervals
                  isServicePlan={props.isServicePlan}
                  serviceIntervalsList={serviceIntervalsList}
                  showTotals={props.showTotals}
                  selectedModelVariant={selectedModelVariant}
                ></ServicePlanPriceIntervals>
              </div>
            </div>
            <div className="pricingDisclaimer">All prices include GST</div>
            <div
              dangerouslySetInnerHTML={{
                __html: props.showTotals
                  ? modelServicePlanContent
                  : modelCappedPriceServiceContent,
              }}
            />
          </div>
        )}
      </div>
    );
  }
);

export default ServicePlanPriceGuide;
